export default "__VITE_ASSET__CmLSq63z__"